import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      padding: '20px',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    inputError: {
      color: 'red',
    },
    otpInputStyledWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '10px',
      fontWeight: 500,
      fontSize: '20px',
      height: '45px',
      width: '59px',
      '& input': {
        height: '45px',
        width: '59px',
        background: '#FFFFFF1A',
        border: '0.8px solid #959EB2',
        outlineColor: '#019DE6',
        outlineWidth: '1px',
        borderRadius: '8px',
        padding: '12px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
      },
    },
    otpInputWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: 500,
      fontSize: '20px',
    },
    otpInput: {
      height: '45px',
      width: '59px',
      background: '#FFFFFF1A',
      border: '0.8px solid #959EB2',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      padding: '12px',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    },
    inputDescription: {
      color: '#8C8C8C',
      marginTop: '8px',
      ...getTypographyStyles('content_xs_regular'),
    },
    resend: {
      backgroundColor: '#00000000',
      marginTop: '8px',
      padding: '0px',
      border: 'none',
      color: colors.primary.default,
      ...getTypographyStyles('content_xs_semibold'),
    },
    inputLeft: {
      fontWeight: 500,
      fontSize: '16px',
    },
    descContainer: {
      display: 'flex',
      gap: '2px',
      flexWrap: 'wrap',
      color: colors.primary.default,
      marginBottom: '32px',
      flexDirection: 'column',
      ...getTypographyStyles('content_sm_regular'),
    },
    changeEmailLink: {
      all: 'unset',
      display: 'flex',
      gap: '4px',
      cursor: 'pointer',
      lineBreak: 'anywhere',
      marginBottom: '8px',
      ...getTypographyStyles('content_sm_medium'),
    },
    emailDescription: {
      ...getTypographyStyles('content_sm_regular'),
      color: colors.primary.default,
    },
    pinInputWrapper: {
      marginRight: 8,
    },
  };
});

export default useStyles;
